<div
  [ngClass]="{ square: type === 'square', circle: type === 'circle' }"
  [ngStyle]="{ width: imgWidth, height: imgHeight, overflow: 'hidden' }"
  [attr.alt]="alt"
>
  @if (showPicture()) { @if (fullName) {
  <img class="avatar-image" [src]="src" [attr.alt]="alt || fullName" (error)="onImageError()" />
  } @else {
  <img [imgPreloader]="src" [attr.alt]="alt" />
  } } @else if (fullName) {
  <div class="initials">
    <span [ngStyle]="{ 'font-size': fontSize() }">
      {{ fullName | getInitials }}
    </span>
  </div>
  }
</div>
